import { AfterContentInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { OrganizationService } from '../../../shared/services/organization.service';
import { AmplitudeService } from '../../../shared/services/amplitude.service';

@Component({
    selector: 'logout',
    template: '',
    standalone: false
})
export class LogoutComponent implements AfterContentInit {
  constructor(
    private amplitudeService: AmplitudeService,
    private organizationService: OrganizationService,
    private router: Router
  ) {
    this.organizationService.setOrganization();
    this.amplitudeService.logout();
  }

  ngAfterContentInit() {
    this.router.navigateByUrl('/');
  }
}

